import { useGetMillwrightsByOutageIdAndTaskIdQuery } from '@/apis/millwrights/millwrightsApi';
import { BackButton } from '@/components';
import { SPINNER_SIZE } from '@/constants';
import { MillwrightCard } from '@/pages/Millwrights/components';
import {
  LoadingSpinner,
  Stack,
  Typography,
} from '@data-products-and-ai/react-components';
import { useParams } from 'react-router';

import '@/pages/Tasks/[ID]/styles.scss';

export const OutageTaskPage = () => {
  const { taskId, outageId } = useParams();

  const { data, isLoading } = useGetMillwrightsByOutageIdAndTaskIdQuery(
    { outageId: Number(outageId), taskId: taskId ?? '' },
    {
      skip: !taskId || !outageId,
    },
  );

  const millwrights = data?.results || [];
  const taskDescription = millwrights[0]?.taskDescription ?? taskId;

  if (!taskId || !outageId) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="outages-page-spinner">
        <LoadingSpinner
          text="Loading task millwrights..."
          size={SPINNER_SIZE}
          color="var(--color-primary)"
          align="center"
          tag="textdefault"
          inline
        />
      </div>
    );
  }

  return (
    <div className="task-page">
      <Stack wrap direction="row" distribute="space-between" gap={16}>
        <Typography color="var(--color-black)" tag="h3">
          {taskDescription}
        </Typography>
        <BackButton url={`/outages/${outageId}`} />
      </Stack>
      {millwrights.length > 0 ? (
        <div className="task-page__cards">
          {millwrights.map((millwright) => (
            <MillwrightCard key={millwright.empId} millwright={millwright} />
          ))}
        </div>
      ) : (
        <Stack>
          <Typography color="var(--color-default)" tag="textdefault">
            No millwrights found
          </Typography>
        </Stack>
      )}
    </div>
  );
};
